
import searchBar from '@/components/SearchBar';
import list from './component/listItem';
import { getItavMaterialList } from '@/api/res_store/list';

export default {
  components: {
    searchBar: searchBar,
    list: list
  },
  data: function data() {
    return {
      aList: [],
      bListLoading: true,
      nPage: 1,
      nPageSize: 15,
      nTotal: 1,
      oSearchData: {},
      aSearchProp: {
        searchField: true,
        keyword: true,
        defaultKey: 'name',
        customSelector: [{
          selectorId: 'tag2_id',
          name: '标签',
          tagId: 6,
          multiple: true
        }, {
          selectorId: 'cat1_id',
          name: '分类',
          multiple: true,
          data: [{ id: '1', name: '龙骨动画' }, { id: '2', name: '序列帧动画' }]
        }],
        aSearchField: [{
          id: 'name',
          name: '请输入名称关键字'
        }]
      }
    };
  },
  mounted: function mounted() {
    this.fnRenderList();
  },


  methods: {
    fnRenderList: function fnRenderList(data) {
      var oTemp = {};
      var self = this;
      if (data) {
        self.oSearchData = data;
        self.nPage = 1;
      }
      oTemp = self.oSearchData;
      oTemp.cat2_id = 1;
      oTemp.res_type = 3;
      oTemp.page = self.nPage;
      self.bListLoading = true;
      getItavMaterialList(oTemp).then(function (res) {
        self.bListLoading = false;
        self.aList = res.data.data.list;
        self.nTotal = res.data.data.total;
      });
    },
    fnCurrentChange: function fnCurrentChange(val) {
      this.nPage = val;
      this.fnRenderList();
    }
  }
};